export default __webpack_public_path__ + "static/media/lnd_table.cac5f133.webp";